/** `{stem}-failed.csv`; re-downloading an already-`-failed` file keeps the same name (spec §4.8). */
export const computeFailedCsvFilename = (originalFileName: string): string => {
  const stem = originalFileName.replace(/\.csv$/i, '');
  const withSuffix = stem.toLowerCase().endsWith('-failed') ? stem : `${stem}-failed`;
  return `${withSuffix}.csv`;
};

export const downloadFailureCsv = (csvContent: string, filename: string): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
